module.exports = __webpack_public_path__ + "media/images/app/checkout/chevron-down-29b27ece4cf25b5de6b5d86691b34983.svg";